import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Dialog,
  DialogContent,
  IconButton,
  Skeleton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slider from "react-slick";
import axios from "axios";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

import StarIcon from '@mui/icons-material/Star';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import BusinessIcon from '@mui/icons-material/Business';


const clients = [
  {
    name: "JK Cement - Buildwell",
    logo: "/assets/JK-Cement-unveils-its-new-corporate-identity-with-a-refreshed-logo.webp",
    testimonial: "Their innovative approach and on-time delivery are truly commendable."
  },
  {
    name: "Ultratech - Kamal Builders",
    logo: "/assets/RPOADOV5DFKHZA5XDCQ2CGXPFY.jpg",
    testimonial: "Outstanding quality and customer service throughout our collaboration."
  },
  {
    name: "KJS Cement - Buildwell Maihar",
    logo: "/assets/51z8mD8HrBL._UF1000,1000_QL80_.jpg",
    testimonial: "Professional, reliable and always going above expectations."
  },
  {
    name: "JK Cement - Aanad Trading Company",
    logo: "/assets/download.png",
    testimonial: "Their dedication and timely support helped us deliver critical projects."
  },
  {
    name: "Dalmia Cement - Interspace Design",
    logo: "/assets/1.jpeg",
    testimonial: "Great teamwork and commitment to excellence."
  },
  {
    name: "JK Cement - Karni Design Pvt. Ltd.",
    logo: "/assets/J._K._Organisation.svg.png",
    testimonial: "We truly appreciate their precision and project understanding."
  },
  {
    name: "JK Cement - Kamal Counsbuild Pvt. Ltd.",
    logo: "/assets/images.jpeg",
    testimonial: "Their solution-oriented mindset impressed our management."
  },
  {
    name: "Ultratech - Kamal Counsbuild Kotputli",
    logo: "/assets/images.jpeg",
    testimonial: "A trustworthy partner with deep industry knowledge."
  },
  {
    name: "Shree Digvijay Cement - Tarun Construction",
    logo: "/assets/Contents-Banner01.jpg",
    testimonial: "Consistent support and exceptional professionalism."
  },
  {
    name: "Moggerbear Power Plant - Kamal Counsbuild",
    logo: "/assets/images.jpeg",
    testimonial: "Their execution speaks volumes about their capability."
  },
  {
    name: "Ultratech - Kamal Counsbuild Tadipatri (AP)",
    logo: "/assets/images.jpeg",
    testimonial: "Dependable, transparent, and always aligned with our vision."
  }
];




const getStars = () => {
  const rating = (Math.random() * 1 + 4).toFixed(1);
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  return { full, half };
};

function Home() {
  const [open, setOpen] = useState(false);
  const [services, setServices] = useState([])
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate()
  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };


  const carouselItems = [
    { type: "image", src: "https://res.cloudinary.com/dcyszo7yw/image/upload/v1751560274/uo8p5u7bbjymylrn66od.jpg" },
    { type: "video", src: "https://res.cloudinary.com/dcyszo7yw/video/upload/v1751560208/a5vrxmri3fwnrrkmysg9.mp4" },
    { type: "imgae", src: "https://res.cloudinary.com/dcyszo7yw/image/upload/v1751561495/l6ym4vowg2qvkoztdazt.jpg" }
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };


  useEffect(() => {
    const token = localStorage.getItem('token');


    axios({
      method: "GET",
      url: `${process.env.REACT_APP_MY_API}/api/services/686154b5cbe093c404c97c5b`,
      headers: {
        Authorization: `Bearer ${token}` // ✅ Fix here
      }
    })
      .then((res) => {

        setServices(res.data);
        setLoading(false)
      })
      .catch((err) => {
        console.error("Failed to fetch services:", err);
        setLoading(false)
      });
  }, []);



  return (
    <>
      <Helmet>
        <title>Top Painting Services in India | PM Painters</title>
        <meta name="description" content="Welcome to PM Painters – India’s trusted experts in residential, commercial, interior and exterior painting. Get a free consultation today!" />
        <meta name="keywords" content="painting services India, interior painting, exterior painting, house painters, commercial painting Ahmedabad" />
      </Helmet>

      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: { xs: 350, sm: 500, md: 600 },
          overflow: "hidden",
          mb: 4,
        }}
      >
        <Slider {...settings}>
          {carouselItems.map((item, index) => (
            <Box key={index} sx={{ width: "100%", height: "100%" }}>
              {item.type === "video" ? (
                <Box sx={{ width: "100%", height: "100%" }}>
                  <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  >
                    <source src={item.src} type="video/mp4" />
                  </video>
                </Box>
              ) : (
                <img
                  src={item.src}
                  alt={`Slide ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                />
              )}
            </Box>
          ))}
        </Slider>

        {/* 🔤 Overlay Text */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            textAlign: "center",
            color: "#fff",
          }}
        >
          <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3.5rem" },
                mb: 1,
                px: { xs: 2 },
                lineHeight: 1.2,
              }}
            >
              Welcome to PM Enterprise
            </Typography>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 60 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 1 }}>
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "0.95rem", sm: "1.2rem", md: "1.5rem" },
                maxWidth: "90%",
                mb: 2,
                px: { xs: 2 },
                lineHeight: 1.3,
              }}
            >
              Quality Painting & Finishing Services Since 2003
            </Typography>
          </motion.div>

          <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.6, duration: 0.8 }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{
                fontSize: { xs: "0.75rem", sm: "0.9rem", md: "1rem" },
                px: { xs: 3, sm: 4 },
                mt: 2,
              }}
              onClick={() => navigate('/services')}
            >
              Explore Our Services
            </Button>
          </motion.div>
        </Box>
      </Box>

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <Typography variant="h4" align="center" gutterBottom>
            What We Offer
          </Typography>
        </motion.div>

        <Grid container spacing={4} sx={{ my: 4 }}>
          {loading
            ? Array.from(new Array(6)).map((_, index) => (
              <Grid item xs={12} sm={6} md={6} key={index}>
                <Card sx={{ maxWidth: 345 }}>
                  <Skeleton variant="rectangular" width={210} height={118} />
                  <CardContent>
                    <Skeleton height={28} width="100%" />
                    <Skeleton height={20} width="100%" />
                    <Skeleton height={20} width="100%" />
                  </CardContent>
                </Card>
              </Grid>
            ))
            : services.map((service, index) => (
              <Grid item xs={12} sm={6} md={6} key={index}>
                <Card sx={{
                  maxWidth: 345,
                  borderRadius: 3,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "scale(1.03)",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                  },
                }}>
                  <CardMedia
                    component="img"
                    image={service.icon}
                    alt={service.title}
                    sx={{ height: 150, width: "100%", objectFit: "cover" }}
                  />
                  <CardContent sx={{ height: 150, p: 2, display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                    <Typography variant="h6" gutterBottom noWrap marginBottom={0}>
                      {service.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                      {service.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
        </Grid>
      </Container>

      <Container maxWidth="lg" sx={{ mt: 6, mb: 6 }}>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Our Esteemed Clients
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 4, color: 'text.secondary' }}>
            Proudly serving leading companies & government organizations across India
          </Typography>
        </motion.div>

        <Slider {...settings}>
          {clients.map((client, idx) => {
            const { full, half } = getStars();
            return (
              <Box
                key={idx}
                sx={{
                  px: 2,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: idx * 0.1, duration: 0.4 }}
                >
                  <Box
                    sx={{
                      bgcolor: "background.paper",
                      p: 2,
                      borderRadius: 2,
                      border: "2px solid",
                      borderColor: "primary.main",
                      boxShadow: "0 4px 20px rgba(25, 118, 210, 0.3)",
                      textAlign: "center",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: 'transform 0.3s, box-shadow 0.3s',
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: "0 6px 30px rgba(25, 118, 210, 0.5)"
                      }
                    }}
                  >

                    {client.logo ? (
                      <Box component="img" src={client.logo} alt={client.name} sx={{ height: 40, mb: 1, objectFit: "contain" }} />
                    ) : (
                      <BusinessIcon sx={{ fontSize: 40, color: "primary.main", mb: 1 }} />
                    )}

                    <Typography sx={{ fontWeight: 600, fontSize: { xs: "0.85rem", sm: "1rem" }, mb: 1 }}>
                      {client.name}
                    </Typography>

                    <Box sx={{ display: "flex", justifyContent: "center", color: "#fbc02d" }}>
                      {[...Array(full)].map((_, i) => <StarIcon key={i} fontSize="small" />)}
                      {half && <StarHalfIcon fontSize="small" />}
                    </Box>

                    <Typography
                      variant="body2"
                      sx={{
                        fontStyle: "italic",
                        mt: 1,
                        color: "text.secondary",
                        fontSize: { xs: "0.75rem", sm: "0.85rem" },
                      }}
                    >
                      “{client.testimonial}”
                    </Typography>
                  </Box>
                </motion.div>
              </Box>
            );
          })}
        </Slider>
      </Container>
    </>

  );
}

export default Home;
